$(document).ready(function () {
    $('.online_applications__list-item').each(function () {

        let textId = $(this).find('.online_applications__list-item-left p:first-child').attr('id') || $(this).find('.online_applications__list-item-left li:first-child').attr('id');

        $(this).find('.online_applications__list-item-right a.wp-block-button__link').attr('id', 'apply_' + textId);
        $(this).find('.online_applications__list-item-right a.wp-block-button__link').attr('aria-labelledby', 'apply_' + textId + ' ' + textId);

    });
});